<template>
    <div>
        <div class="accordion-block" v-for="(item, id) in checkoutItems" :key="id">
            <div class="accordion-toggle" block v-b-toggle="'accordion-' + id " variant="info">
                {{ strings.day }} {{ id + 1 }}
                <span class="accordion-plus">+</span>
                <span class="accordion-minus">-</span>
            </div>
            <b-collapse :visible="id == 0" v-bind:id="'accordion-' + id "  accordion="my-accordion" role="tabpanel">
                <b-card>
                    <div class="full-info-item">
                        <div class="info-label">{{ strings.startTime }}</div>
                        <div class="info room-detail">{{ item.startD }}</div>
                    </div>
                    <div class="full-info-item">
                        <div class="info-label">{{ strings.endTime }}</div>
                        <div class="info room-detail">{{ item.endD }}</div>
                    </div>
                    <div class="full-info-item">
                        <div class="info-label">{{ strings.Room }}</div>
                        <div class="info room-detail">{{ item.room.name }} ({{ item.room.layout_name }})</div>
                    </div>
                    <div v-show="item.type == 'package'" class="full-info-item">
                        <div class="info-label">{{ strings.DDRPackage }}</div>
                        <div class="info room-detail">{{ item.package.name }}</div>
                    </div>
                    <div class="full-info-item">
                        <div class="info-label">{{ strings.Delegates }}</div>
                        <div class="info room-detail">{{ item.delegates }}</div>
                    </div>
                    <div class="full-info-item">
                        <div class="info-label">{{ strings.total }}</div>
                        <div class="info room-detail">{{ parseFloat(item.total_price / 100).toFixed(2) }} {{ item.currencySymbol }}</div>
                    </div>

                    <AddonsList v-if="item.type !== 'package'"  
                        :item_index="id" 
                        :currency_symbol="item.currencySymbol" 
                        :mt_length="item.mt_length"
                        :startD="item.startD"
                        :endD="item.endD"
                        ></AddonsList>
                </b-card>
            </b-collapse>	
            </div>
</div>

</template>

<script>
    import moment from 'moment'
    import BootstrapVue from 'bootstrap-vue'
    import AddonsList from './AddonsList'
    import Vue from 'vue'
    Vue.use(BootstrapVue);

    export default {
        name: 'MultiDayCheckout',
        filters: {
            // to Array
            formatDate(value) {
                if (value) {
                    return moment(value, 'DD-MM-YYYY HH:mm').format('DD-MM-YYYY');
                }
            }
        },
        props: ['misc', 'menus'],
        components: {
            AddonsList
        },
        computed: {
            venue(){
                return this.$store.state.venueInfo;
            },
            strings () {
                return this.$store.state.strings;
            },
            checkoutItems () {
                return this.$store.state.checkOutItemsOpera;
            }
        },
        methods: {
            createMultiBooking(){

            },
            show(){

            }
        }
    }
</script>

<style scoped>
.card{
    margin-bottom: 15px;
    border-top:none;
    margin-top: -20px;
}
.accordion-toggle{
    border-bottom: 1px solid rgba(0,0,0,.125);
    border-radius: .25rem;
    cursor:pointer;
    margin-bottom: 20px;
}
.accordion-block .btn-info{
    background: rgb(0, 85, 169);
}
.accordion-plus, .accordion-minus{
    font-weight: 400;
    float: right;
    font-size: 25px;
    line-height: 20px;
}

:not(.collapsed) > .accordion-plus{
    display: none;
}
.collapsed > .accordion-plus{
    display: block;
}

.collapsed > .accordion-minus{
    display: none;
}
:not(.collapsed) > .accordion-minus{
    display: block;
}
.accordion-block .info-label{
    float: left;
    margin-right: 10px;
    font-weight: bold;
    font-size: 14px;
}

.accordion-block .room-detail{
    font-size: 14px;
}

</style>